<template>
  <base-modal :body_class="body_class">
    <template slot="title">
      <template v-if="step !== 'init'">
        <back-title @on-back="$emit('on-back')">{{ default_title }}</back-title>
      </template>
      <template v-else>{{ default_title }}</template>
    </template>

    <template v-if="$slots['description'] " slot="description">
      <div></div>
    </template>

    <template slot="footer-cancel" slot-scope="{ close }">
      <template v-if="step !== 'init'">
        <i-button size="large" @click="$emit('on-back')">
          {{ $t('pbx.worksheet.modal.action.child.button.cancel') }}
        </i-button>
      </template>

      <template v-else>
        <i-button size="large" @click="close()">
          {{ $t('pbx.worksheet.modal.action.main.button.cancel') }}
        </i-button>
      </template>
    </template>

    <template v-for="slot in Object.keys($scopedSlots)" :slot="slot" slot-scope="scope">
      <slot :name="slot" v-bind="scope"></slot>
    </template>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import BackTitle from './_fragments/title-modal';

  export default {
    components: { BaseModal, BackTitle },
    props: {
      box: {
        type: Object,
        require: true,
        default: () => ({})
      },
      step: {
        type: String,
        default: 'init'
      },

      body_class: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      default_title: function() {
        const path_to_title = `pbx.worksheet.action.${this.box.type}.state.${this.step}.title`;

        if (this.$te(path_to_title)) {
          return this.$t(path_to_title);
        }

        return this.$t(`autoinformer.worksheets.actions.${this.box.type}`);
      }

    }
  };
</script>
